export default {
	options: [{
		value: '0',
		label: '上海速元科技有限公司'
	}, {
		value: '1',
		label: '上海速元科技有限公司'
	}],

	searchlist: [{
			prop: "nsrmc",
			label: '公司主体',
			type: "input"
		},
		{
			prop: "declareType",
			label: '申报期限类型',
			type: "select",
			selectval: [{
					label: "按次申报",
					value: "1"
				},
				{
					label: "按季申报",
					value: "2"
				},
			]
		},
		{
			prop: "taxItem",
			label: '税目',
			type: "input",
		},
		{
			prop: "specificItem",
			label: '子目',
			type: "input"
		},
		{
			prop: "taxPeriod",
			label: '税款所属期',
			type: "datemonth",
			valueformat: 'yyyyMM'
		}
	],
	tableData: [],
	searchdata: {
		nsrmc: "",
		declareType: "",
		taxItem: "",
		specificItem: "",
		taxPeriod: "",
	},
	headData: [{
		title: "公司主体",
		prop: "nsrmc",
		width: 160,
		align: "left"
	}, {
		title: "申报期限类型",
		prop: "declareType",
		custom: true,
		width: 100,
	}, {
		title: "税目",
		prop: "taxItem",
		width: 80,
	}, {
		title: "子目",
		prop: "specificItem",
		width: 80,
	}, {
		title: "税率",
		prop: "taxRate",
		custom: true,
		width: 80,
	}, {
		title: "计税基础",
		prop: "taxBase",
		width: 80,
	}, {
		title: "税款所属期",
		prop: "taxPeriod",
		width: 80,
	}, {
		title: "应税凭证数量",
		prop: "taxableVoucherNum",
		width: 80,
	}, {
		title: "备注",
		prop: "remarks",
		width: 160,
		align: "left"
	},{
		title: "操作",
		prop: "cz",
		width: "200",
		fixed:"right",
		custom:true
	},],
	outputData: {
		exportType: "",
		shenbq: "",
	},
	pagination: {
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey: 0
	}
}
